export default {
    email: '',
    newsletter: false,
    terms: false,
    tag:'',
    firstName:'',
  }